import React from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { notifications } from '@mantine/notifications';
import LoginForm from '../components/LoginForm';
import { login, readCookie } from '../api';

const LoginContainer = () => {
  const navigate = useNavigate()

  const handleSubmit = async (values: any) => {
    try {
      const data = await login(values.email, values.password)
      navigate(`/admin/clients/${data.url_name}`)
    } catch (error) {
      notifications.show({
        message: 'メールアドレスまたはパスワードが違います',
        color: 'red',
        autoClose: 4000,
      });
    }
  };

  const lastClientUrlName = readCookie('last_client_urlname')
  if (lastClientUrlName) {
    return <Navigate replace to={{ pathname: `/admin/clients/${lastClientUrlName}` }} />;
  }

  return (
    <main className='login-container'>
      <section className='login-form-section'>
        <img src="/invy_logo2.png" alt="logo" className='login-logo-content' />
        <LoginForm onSubmit={handleSubmit} />
      </section>

      <section className='login-article-section'>
        <article></article>
      </section>
    </main>
  );
};

export default LoginContainer;
